// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    height: 7vh;
    background-color: #289cef88;
}

nav a {
    text-decoration: none;
    color: black;
    font-size: 1.5em;
    font-weight: bold;
    padding: .25em .5em;
    border-radius: 6px;
}

nav a:hover {
    background-color: #289cef;
}

.nav-burger {
    display: none;
}
.nav-burger-content {
    /*display: none;*/
}
.nav-burger-menu {
    cursor: pointer;
}
.nav-burger-menu > div {
    width: 25px;
    height: 5px;
    border-radius: 5em;
    background-color: black;
    margin: 5px 0;
}

main {
    display: flex;
    flex: 1 1;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    min-height: 100vh;
}

footer {
    display: flex;
    justify-content: space-around;
    padding: .5em 0;
    background-color: #289cef88;
    color: black;
    font-size: 1em;
    font-weight: bold;
}

@media only screen and (max-width: 700px) {
    nav {
        border-bottom: 1px solid #4E7B9B;
        padding: 0;
    }
    .nav-links {
        display: none;
    }
    .nav-burger {
        display: flex;
    }
    .nav-burger-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;
        z-index: 20;
        top: 49px;
        left: 0;
        width: 100%;
        background-color: #71aed9;
        overflow: hidden;
    }
    .nav-burger-content a {
        width: 100%;
        border-radius: 0;
        text-align: center;
        border-bottom: 1px solid #4E7B9B;
    }
}`, "",{"version":3,"sources":["webpack://./src/layouts/MainLayout.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAO;IACP,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,eAAe;IACf,2BAA2B;IAC3B,YAAY;IACZ,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI;QACI,gCAAgC;QAChC,UAAU;IACd;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,OAAO;QACP,WAAW;QACX,yBAAyB;QACzB,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,kBAAkB;QAClB,gCAAgC;IACpC;AACJ","sourcesContent":["nav {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    align-items: center;\n    height: 7vh;\n    background-color: #289cef88;\n}\n\nnav a {\n    text-decoration: none;\n    color: black;\n    font-size: 1.5em;\n    font-weight: bold;\n    padding: .25em .5em;\n    border-radius: 6px;\n}\n\nnav a:hover {\n    background-color: #289cef;\n}\n\n.nav-burger {\n    display: none;\n}\n.nav-burger-content {\n    /*display: none;*/\n}\n.nav-burger-menu {\n    cursor: pointer;\n}\n.nav-burger-menu > div {\n    width: 25px;\n    height: 5px;\n    border-radius: 5em;\n    background-color: black;\n    margin: 5px 0;\n}\n\nmain {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    min-height: 100vh;\n}\n\nfooter {\n    display: flex;\n    justify-content: space-around;\n    padding: .5em 0;\n    background-color: #289cef88;\n    color: black;\n    font-size: 1em;\n    font-weight: bold;\n}\n\n@media only screen and (max-width: 700px) {\n    nav {\n        border-bottom: 1px solid #4E7B9B;\n        padding: 0;\n    }\n    .nav-links {\n        display: none;\n    }\n    .nav-burger {\n        display: flex;\n    }\n    .nav-burger-content {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        position: absolute;\n        z-index: 20;\n        top: 49px;\n        left: 0;\n        width: 100%;\n        background-color: #71aed9;\n        overflow: hidden;\n    }\n    .nav-burger-content a {\n        width: 100%;\n        border-radius: 0;\n        text-align: center;\n        border-bottom: 1px solid #4E7B9B;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
